<template>
    <div class="p20 invoice" v-loading.body="loading">
        <!-- 头部按钮部分 start -->
        <div class="el-row ly-bill-title">
            <el-col :span="12">
                <h1 style="padding-top:5px;">修改发票登记</h1>
            </el-col>
            <el-col :span="12" class="tr">
                <el-button type="primary" @click="submit" size="small" :loading="submitLoad">
                    <i class="fa fa-save" v-if="!submitLoad"></i>&nbsp;提交
                </el-button>
                <ly-router-button size="small">
                    <i class="fa fa-chevron-left"></i>&nbsp;返回
                </ly-router-button>
            </el-col>
        </div>
        <!-- 头部按钮部分 end -->
        <!-- 表单列表 start -->
        <el-card class="box-card mt15">
            <Ly-search-form 
                :config="formConfig" 
                :rules="formRules"
                :is-search="false"
                label-width="120px"
                ref="searchForm">
            </Ly-search-form>
        </el-card>
        <!-- 表单列表 end -->
        <!-- 商品选择组件 start -->
        <el-card class="box-card mt15" ref="productCard"> 
            <ly-table 
                :head="productConfig.slice(0,productConfig.length - 1)" 
                :data="submitForm.productList" 
                :config="tbConfig"
                class="mt15">
            </ly-table>
            <div class="ly-info-product_total">
                合计：<span class="f14 bold">{{submitForm.amount}}</span>
            </div>
        
        
            <!-- <ly-product-table 
                ref="productTable"
                :thead-config="productConfig"
                :is-directive="canWatchTotalAmount"
                v-model="submitForm.productList">
                <el-col :span="24" class="ly-product-total">
                    <el-col :span="20">
                        <label>合计: &nbsp;&nbsp;</label>
                    </el-col>
                    <el-col :span="4">
                        <ly-input-number :min="0" size="small" style="width:190px;" v-model="submitForm.amount"></ly-input-number>
                    </el-col>
                </el-col>
            </ly-product-table> -->
        </el-card>
        <!-- 商品选择组件 end -->
    </div>
</template>
<script>
    /**
     * 三包登记的新增页面
     * @author zjs
     * @time 2017-09-18
     */
    import AddFormConfig from './add-form'
    import AddProductConfig from './add-product'
    import AddRulesConfig from './rules'
    import LySearchForm from '@c/search-form'
    import LyProductTable from '@c/product-table'
    import LyTable from '@c/table'
    import LyRouterButton from '@c/router-button'
    import LyInputNumber from '@c/input-number'

    import {mapGetters} from 'vuex'
    export default {
        mixins: [
            AddFormConfig, 
            AddProductConfig,
            AddRulesConfig
        ],
        components: {
            LySearchForm,
            LyProductTable,
            LyTable,
            LyRouterButton,
            LyInputNumber
        },
        computed: {
            ...mapGetters([
                'userInfo'     
            ]),
            // 总的金额
            totalAmount () {
                let total = 0 
                this.submitForm.productList.forEach(function (el) {
                    // 计算当前货品的金额 update wxq 2018.7.20
                    el.xiaoji = (parseFloat(el.quantity) * parseFloat(el.price)).toFixed(2) || ''
                    // 计算总的金额
                    if (el.xiaoji && !isNaN(el.xiaoji)) {
                        total = (parseFloat(total) + parseFloat(el.xiaoji)).toFixed(2)
                    }
                }, this)
                return total
            }
        },
        data () {
            return {
                loading: true,
                submitLoad: false, // 提交按钮的状态标识
                infoId: 0, // 详情的ID
                submitForm: {
                    uuid: '', 
                    amount: 0, // 货品总价格
                    productList: []
                }, // 提交的表单数据
                watchTotalAmountTime: 0, // 监听变化的时间
                canWatchTotalAmount: false // 标识是否进行总金额的监听计算
            }
        },
        created () {
            AddProductConfig.isTriggerFunc = false
            this.init()
        },
        watch: {
            '$route' (to, from) {
                // 清空之前的输入
                if (to.name === 'InvoiceCheckinEdit') {
                    this.init()
                }
            },
            totalAmount (val) {
                this.timer && clearTimeout(this.timer)
                // 是否可以进行监听的计算
                if (!this.canWatchTotalAmount) {
                    return
                }
                // 避免指令频繁触发
                let time = new Date().getTime()
                if ((time - this.watchTotalAmountTime) < 1500) {
                    this.watchTotalAmountTime = time
                    return
                }
                this.submitForm.amount = val
            }
        },
        methods: {
            init () {
                // 获取详情的ID
                this.infoId = this.$route.params.id
                if (this.infoId) {
                    this.queryEditData()
                } else {
                    this.$message({
                        message: '无ID',
                        type: 'warning'
                    })
                }
            },
            /**
             * 获取要修改的数据
             */
            queryEditData () {
                this.$api.queryArr(['api/invoice', 'edit'], null, [this.infoId]).then((rs) => {
                    this.submitForm = rs
                    // 设置表单中的回填数据
                    this.$refs['searchForm'].initBindFormData(rs)
                    // 货品数据回填
                    // this.$refs['productTable'].replaceProductList(rs.productList)
                    // 设置UUID
                    this.submitForm.uuid = this.$utils.createUUID()
                    // 设置总金额监听在货品渲染之后
                    this.$nextTick(() => {
                        this.loading = false
                        this.timer = setTimeout(() => {
                            this.watchTotalAmountTime = new Date().getTime()
                            this.canWatchTotalAmount = true
                        }, 1000)
                    })
                }).catch((error) => {
                    // 取消加载
                    this.loading = false
                    this.$message({
                        message: error,
                        type: 'warning'
                    })
                })
            },
            submit () {
                // let productList = this.$refs['productTable'].getProductData()
                if (this.$refs['searchForm'].validateForm()) {
                    if (this.submitForm.amount <= 0) {
                        this.$message({
                            message: '请将填写货品合计金额',
                            type: 'warning'
                        })
                    } else {
                        this.submitLoad = true
                        // 获得得查询的字段
                        this.submitForm = Object.assign(this.submitForm, this.$refs['searchForm'].bindForm)
                        // 表单中写入货品列表
                        // this.submitForm['productList'] = productList
                        // 判断发票类为增专票时 地址、电话、开户行以及账号是否为空
                        if (!this.isInvoiceType()) {
                            this.$message({
                                message: '请将填写地址、电话和开户行及账号',
                                type: 'warning'
                            })
                            return false
                        }
                        // 提交数据
                        this.$api.save('api/invoice/' + this.infoId, this.submitForm).then((rs) => {
                            this.$alert('数据提交成功', '新增', {
                                confirmButtonText: '确定',
                                callback: action => {
                                    this.submitLoad = false
                                    // 跳转到详情页面
                                    this.$router.push('/bill/invoice/info/' + rs.id)
                                }
                            });
                            // 更新UUID
                            this.submitForm.uuid = this.$utils.createUUID()
                        }).catch((error) => {
                            this.submitLoad = false
                            this.$message({
                                message: error,
                                type: 'warning'
                            })
                        })
                    }
                } else {
                    this.$message({
                        message: '请将信息填写完整',
                        type: 'warning'
                    })
                }
            },
            /**
            * 判断发票类型是增专票时地址、电话、开户行以及账号须必填的规则
            */
            isInvoiceType () {
                // 判断类型
                if (this.submitForm.invoice_type === '1' && (this.submitForm.invoice.address_phone === '' || this.submitForm.invoice.open_bank_account === '')) {
                    return false
                } else {
                    return true
                }
            }
        },
        destroyed () {
            AddFormConfig.clear()
        }
    }
</script>
<style>
    .invoice .ly-product-total{
        border:1px solid #dfe6ec;
        border-top: 0;
        color: #48576a;
        font-size: 12px;
        padding: 8px 5px;
        text-align: right;
    }
    .invoice .ly-product-total label {
        line-height: 30px;
    }
</style>